import { modes } from "../modes";
import { permissions } from "../permissions/permissions";

export const workRequestPermissionProfile = {
    WORK_REQUEST_FULL_ACCESS: {
        [modes.EDIT_PERMISSION]: [permissions.WORK_REQUEST.FULL_ACCESS]
    }
}
